import { styled } from 'styled-components';
import { useRouteLoaderData } from 'react-router-dom';

const Wrapper = styled.section`
  width: 100vw;
  padding: 120px 24px;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  background-color: #f5f7fb;
`;

const Callout = styled.div`
  background-color: #e9eff9;
  margin: auto;
  width: 560px;
  padding: 12px 24px 16px;
  border-radius: 22px;
`;

const Header = styled.h1`
  color: #18224f;
  font-weight: 500;

  &::after {
    width: 100%;
    height: 1px;
    content: '';
    display: block;
    color: #cad5e7;
    background-color: #cad5e7;
    margin-top: 0.83em;
  }
`;

const Link = styled.a`
  color: #4a75ce;
  text-decoration: none;
  font-weight: 500;
`;

const Text = styled.p`
  color: #414b78;
  opacity: 0.94;
  font-weight: 500;
  line-height: 1.4;
`;

/**
 * Callout to render when an org has no dashboards
 */
function NoDashboards() {
  const { organization } = useRouteLoaderData('org');
  return (
    <Callout>
      <Header>No dashboards in organization</Header>
      <Text>
        There are no dashboards in the organization you selected. Please switch
        to a different organization, or learn how to{' '}
        <Link
          href={`${organization?.help_url}/en/index-en.html?contextId=usecases`}
        >
          create a dashboard
        </Link>
        .
      </Text>
    </Callout>
  );
}

/**
 * Callout to render when an org has dashboards
 */
function HasDashboards() {
  const { organization } = useRouteLoaderData('org');
  return (
    <Callout>
      <Header>Select a dashboard</Header>
      <Text>
        To get started, select a dashboard from the menu, or learn how to{' '}
        <Link
          href={`${organization?.help_url}/en/index-en.html?contextId=usecases`}
        >
          create a dashboard
        </Link>
        .
      </Text>
    </Callout>
  );
}

/**
 * The component to display when a dashboard is not found
 *
 * @returns {JSX.Element} - the not found component
 */
export default function Organization() {
  const { projects } = useRouteLoaderData('org');
  return (
    <Wrapper>
      {projects?.length > 0 ? <HasDashboards /> : <NoDashboards />}
    </Wrapper>
  );
}
